export default __webpack_public_path__ + "static/media/wise.6e113dac.jpg";